import { render } from "./ProjectionTable.vue?vue&type=template&id=5a8b45f4"
import script from "./ProjectionTable.vue?vue&type=script&lang=js"
export * from "./ProjectionTable.vue?vue&type=script&lang=js"

import "./ProjectionTable.vue?vue&type=style&index=0&id=5a8b45f4&lang=css"

import exportComponent from "/Users/danielseguin/Documents/Websites/ootp-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__